"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var classnames_1 = (0, tslib_1.__importDefault)(require("classnames"));
var react_1 = (0, tslib_1.__importDefault)(require("react"));
var key_codes_1 = (0, tslib_1.__importDefault)(require("../../constants/key-codes"));
var content_slider_scss_1 = (0, tslib_1.__importDefault)(require("./content-slider.scss"));
var withStyles_1 = require("../../../common/utils/withStyles");
var ContentSlider = /** @class */ (function (_super) {
    (0, tslib_1.__extends)(ContentSlider, _super);
    function ContentSlider() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        // When navigation by tab, content can be scrolled by browser to show not visible focused elements
        // Used to move scroll back to initial state on blur not fully displayed last item at Lightbox
        _this.preventScrollOnTab = function (event) {
            if (event.keyCode !== key_codes_1.default.TAB || !_this.containerRef.current) {
                return;
            }
            _this.containerRef.current.scrollLeft = 0;
        };
        _this.containerRef = react_1.default.createRef();
        _this.contentRef = react_1.default.createRef();
        _this.handleTransitionEnd = function (event) {
            if (event.target === _this.contentRef.current) {
                if (_this.props.onTransitionEnd !== undefined) {
                    _this.props.onTransitionEnd();
                }
            }
        };
        return _this;
    }
    ContentSlider.prototype.componentDidMount = function () {
        document.addEventListener('keydown', this.preventScrollOnTab);
    };
    ContentSlider.prototype.componentWillUnmount = function () {
        document.removeEventListener('keydown', this.preventScrollOnTab);
    };
    ContentSlider.prototype.getCurrentPageOffset = function () {
        var _a = this.props, currentPageNumber = _a.currentPageNumber, width = _a.width, isRTL = _a.isRTL;
        var translateX = currentPageNumber * width * (isRTL ? 1 : -1);
        return {
            transform: "translate3d(".concat(translateX, "px, 0, 0)"),
        };
    };
    ContentSlider.prototype.render = function () {
        var _a;
        var _b = this.props, children = _b.children, disabled = _b.disabled, className = _b.className, dataHook = _b.dataHook, isRTL = _b.isRTL;
        var contentStyles = (0, classnames_1.default)(content_slider_scss_1.default.content, (_a = {},
            _a[content_slider_scss_1.default.disabled] = disabled,
            _a[content_slider_scss_1.default.rtl] = isRTL,
            _a[content_slider_scss_1.default.ltr] = !isRTL,
            _a));
        return (react_1.default.createElement("div", { "data-hook": dataHook, className: (0, classnames_1.default)(content_slider_scss_1.default.container, className), ref: this.containerRef },
            react_1.default.createElement("div", { className: contentStyles, ref: this.contentRef, onTransitionEnd: this.handleTransitionEnd, "data-hook": "content-slider-content", style: this.getCurrentPageOffset() }, children)));
    };
    ContentSlider = (0, tslib_1.__decorate)([
        (0, withStyles_1.withStyles)(content_slider_scss_1.default)
    ], ContentSlider);
    return ContentSlider;
}(react_1.default.Component));
exports.default = ContentSlider;
//# sourceMappingURL=content-slider.js.map